import styled, { css } from 'styled-components';
import theme from '../../styles/material';
import { shade } from 'polished';
import colors from '../../styles/colors';

const OnlineStatusProps = {
  1: css`
    background: green;
  `,
  2: css`
    background: red;
  `,
  4: css`
    background: yellow;
  `,
  8: css`
    background: #999;
  `,
};

// 1. Root Two-Column Layout
export const Content = styled.div`
  display: flex;
  flex-direction: row;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  color: #666;
  background-color: #fff;
`;

// 2. Left Side: Sidebar Container
export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 420px;
  min-width: 320px;
  max-width: 420px;
  height: 100%;
  border-right: 1px solid #f0f0f0;
  background-color: #fff;
  position: relative;
`;

// 3. Left Header
export const Header = styled.div`
  background-color: #f9f9f9;
  border-bottom: 1px solid #f0f0f0;
  color: #666;
  padding: 0 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  min-height: 60px;
  box-sizing: border-box;
`;

// 4. Left Search Area
export const SearchArea = styled.div`
  height: 48px;
  min-height: 48px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 0 10px;
  box-sizing: border-box;

  svg {
    width: 20px;
    height: 20px;
    margin: 0 10px;
    cursor: pointer;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  padding: 8px 12px;
  font-size: 14px;
  outline: none;
  background: transparent;
  &:active,
  &:focus {
    background: #f0f2f5;
    border-radius: 6px;
  }
`;

// 5. Left Conversation List (Scrollable)
export const ConversationsContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
  display: flex;
  flex-direction: column;
`;

export const ConversationItem = styled.div`
  position: relative;
  background-color: #fff;
  padding: 15px;
  border-top: 2px solid #f9f9f9;
  border-bottom: 2px solid #f9f9f9;
  transition: background-color 0.8s;
  display: flex;
  + div {
    border-top: none;
  }
  cursor: pointer;
  ${(props) =>
    props.isSelected === true &&
    css`
      background-color: ${shade(0.1, '#f9f9f9')};
    `}

  transition: filter 0.2s;

  &:hover {
    ${(props) =>
      props.isSelected === undefined &&
      css`
        filter: brightness(0.95);
      `}
    ${(props) =>
      props.isSelected === false &&
      css`
        filter: brightness(0.95);
      `}
  }
`;

export const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-left: 5px;
  height: 30px;
`;

export const ArchiveContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 5px;
  height: 30px;
`;

export const Status = styled.div`
  ${(props) => OnlineStatusProps[props.status]}
  width: 16px;
  height: 16px;
  border-radius: 16px;
`;

export const StatusForSSE = styled.div`
  ${(props) => OnlineStatusProps[props.status]}
  width: 10px;
  height: 10px;
  border-radius: 10px;
`;

export const Reads = styled.div`
  position: absolute;
  top: 10px;
  right: 5px;
  height: 16px;
  width: 16px;
  padding: 5px;
  border-radius: 100%;
  background-color: ${colors.primary};
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  place-content: center;
  place-items: center;
`;

export const DateTimeMessage = styled.h4`
  position: absolute;
  top: 12px;
  right: 25px;
  font-size: 10px;
  max-width: 130px;
  ${(props) =>
    !props.unreadLabel &&
    css`
      right: 10px;
    `}
`;

export const ButtonsContainer = styled.div`
  display: flex;
  color: #666;
  padding-top: 3px;
  svg {
    cursor: pointer;
    margin: 5px;
    &:hover {
      color: ${colors.primary};
    }
  }
`;

export const ButtonsContainerMenu = styled.div`
  display: flex;
  align-items: center;
  color: #666;
  height: 100%;

  svg {
    cursor: pointer;
    margin: 5px;
    &:hover {
      color: ${colors.primary};
    }
  }
`;

export const ItensContainerMenu = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${shade(0.1, '#f9f9f9')};
  }
  ${(props) =>
    props.isSelected === true &&
    css`
      background-color: ${shade(0.1, '#f9f9f9')};
    `}
`;

// 6. Right Side: Chat Main Viewport
export const ChatMainContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #f0f0f0;
`;

export const HeaderChat = styled.div`
  border-bottom: 1px solid #e0e0e0;
  background-color: #f9f9f9;
  color: #666;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  min-height: 60px;
  z-index: 10;
  box-sizing: border-box;

  div {
    display: flex;
    span {
      font-size: 11px;
      color: #606060;
    }
  }
`;

export const Profile = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  column-gap: 5px;
`;

// 7. Right Side: Welcome Screen (No Conversation Selected)
export const WelcomeContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  color: #495057;
  height: 100%;
  width: 100%;
`;

export const WelcomeContent = styled.div`
  text-align: center;
  max-width: 100%;
  padding: 35px;

  & > svg:first-child {
    color: ${colors.primary};
    margin-bottom: 20px;
  }

  h3 {
    font-size: 17px;
    color: #343a40;
    margin-bottom: 25px;
    font-weight: 500;
    line-height: 1.4;
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 14px;

    p {
      display: flex;
      align-items: center;
      column-gap: 12px;
      font-size: 14px;
      color: #495057;
      margin: 0;
      font-weight: 500;

      svg {
        color: ${colors.primary};
      }
    }
  }
`;

export const ConnectionWarning = styled.div`
  width: 100%;
  text-align: center;
  padding: 4px 0;
  font-size: 14px;
  color: black;
  --bg-opacity: 0.5;
  // background-color: rgba(254, 215, 170, var(--bg-opacity));
  // background-color: rgba(254, 235, 200, 0.5);
  background-color: rgba(254, 235, 200, var(--bg-opacity));
  border-top: 1px solid #fb923c;
  border-bottom: 1px solid #fb923c;
`;

export const ConnectionWarningContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const ConnectionWarningIcon = styled.div`
  flex-shrink: 0;
  color: #ea580c;
`;
